import React ,{ useState }from "react";

import { Bounce } from 'react-activity';
import 'react-activity/dist/react-activity.css';

import Drawer from '@material-ui/core/Drawer';

import { getMenus,getJobRequests,getJobServiceTypes,getJobNotes,getJobById,dpArchive,dpRetrieve,getJobSummary,completeTask,getScreenFields,updateNoti,getSettings,getMaster,getJobStatus,getPatientRights,getAccounts ,getDpExport} from "../../crud/auth.crud";
import { Link } from "react-router-dom";
import { IconButton,TextField,MenuItem,InputLabel,Select } from '@material-ui/core';
import { Tooltip } from "@material-ui/core";	
//import InfiniteScroll from "react-infinite-scroller";
import SearchIcon from '@material-ui/icons/Search';
import DateFnsUtils from '@date-io/date-fns';
import {
  Portlet,
  PortletBody,
//  PortletHeader,
//  PortletHeaderToolbar
} from "../../partials/content/Portlet";
import {  format } from 'date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import Grid from '@material-ui/core/Grid';					
import EditIcon from '@material-ui/icons/Edit';		
import Checkbox from '@material-ui/core/Checkbox';
//import PaymentIcon from '@material-ui/icons/Payment';
import DescriptionIcon from '@material-ui/icons/Description';
import ReceiptIcon from '@material-ui/icons/Receipt';

import Button from '@material-ui/core/Button';
//import SaveIcon from '@material-ui/icons/Save';
import Icon from '@material-ui/core/Icon';
 import CodeExample from "../../partials/content/CodeExample";
//import setDisplay from "../../partials/content/CodeExample";
import EditJobrStatus from './EditJobrStatus'

 import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
//import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
 
import Autocomplete from '@material-ui/lab/Autocomplete';
//import { ThreeDRotationSharp, TrendingUpOutlined } from "@material-ui/icons";
import InvoiceAttributes from "../../widgets/InvoiceAttributes";
import Invoice from "../../widgets/Invoice";

import EditJobRequest from "./EditJobRequest";
//import { update } from "lodash";


//import Moment from 'moment';
 

export default class DigitalPlanner extends React.Component {
 
  handleDateChange = (date) => {
    this.setState({selectedDate : date});
  };

  state = {
    schedules:[],
    pRights:[],
    hasMoreItems:false,
    page:1,
        isReset:false,

    isLoading:false,
        filterFields :{},
    fields:[],
    filter:false,
    selectedDate:null,
    open:false,
    notes:[],
    notesId:'',
    statusSettings:
        "JOBS00003"
    ,
    postObj:{},
	statusFilter:null,
	selectedDrawerItem:null,
	invoiceDrawerOpen:false,
	invoiceViewDrawerOpen:false,
	jobServiceTypes:[],
	permission:[],
	summary:[],
	totalRecords:0,
	showall:0,
	showtodo:false,
	selectedRequest: null,
	
  }

 constructor(props)
{
	super(props);


}


handleCloseInvoiceDrawer()
{
	this.setState({invoiceDrawerOpen:false});
}

handleDpDialogClose= async () =>
	{

		/*console.log("selected ::::",this.state.tPentity);
		let pentity = this.state.tPentity;
		let postObj = {pEntityKey:pentity.pEntityId};
		let completed=0;
		let pending=0;
		getPatientRights(1,postObj)
		.then((response) => {
			 pending = response.data.length;
			 this.setState({pRights: this.state.pRights.map(el => (el.id === pentity.id ? {...el,digitalPlannerStatus: response.data.digitalPlannerStatus}: el))});	
			

		});


		
		*/
		if(this.state.selectedRequest!==null)
		{
			await getJobById(this.state.selectedRequest.id)
			.then((response) => {
				const row = response.data;
				console.log("row:::",row);

				let allRecords = this.state.schedules;
				let index = allRecords.findIndex(el => el.id == row.id);
				
				allRecords[index] = row;
				//console.log("ipdate data::::::",index, allRecords[index]);
				this.setState({schedules:allRecords});
				//this.setState({schedules: this.state.schedules.map(el => (el.id === this.state.selectedRequest.id ? {...el, row}: el))});	
				

			});
		}
		this.setState({dpDialogOpen:false});
	}


handleCloseInvoiceViewDrawer()
{
	this.setState({invoiceDrawerViewOpen:false});
}

handleOpenInvoiceDrawer(jobRequest)
{
	this.setState({invoiceDrawerOpen:true,selectedDrawerItem:jobRequest});
}

handleOpenInvoiceViewDrawer(jobRequest)
{
	this.setState({invoiceDrawerViewOpen:true,selectedDrawerItem:jobRequest});
}

toggleInvoiceDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    this.setState({invoiceDrawerOpen:false})
  };

  
toggleInvoiceViewDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    this.setState({invoiceDrawerViewOpen:false})
  };


  archive(jobrequest,flag)
	{
		if(flag)
		{
			if (window.confirm("Are you sure you want to archive "+jobrequest.pEntity.firstName + " "+jobrequest.pEntity.lastName+"?")) 
			{
			dpArchive(jobrequest.id)
			.then((response) => {
				//
				let schedules = this.state.schedules;
				let index = this.state.schedules.findIndex(el => el.id == jobrequest.id);
						  
				schedules.splice(index,1);
				this.setState({schedules:schedules});
			});
		}
		}
		else
		{
			dpRetrieve(jobrequest.id)
		.then((response) => {
			//
			let schedules = this.state.schedules;
				let index = this.state.schedules.findIndex(el => el.id == jobrequest.id);
						  
				schedules.splice(index,1);
				this.setState({schedules:schedules});
		});
		}
  
		//this.setState({open:true,tPentity:pentity,tStatus: pentity.status});
	}


resetFilter()
{
	let postObj={};
  		//this.state.filter=false;
  		  		this.setState({isReset:false});
  		  		
  		  		this.setState({filter:false},function(){
					this.setState({filter:true})		
  		  		})
				
  		  		
  	 	this.state.fields[0].fields.map((field)=> {
  			
  			this.state[`Filter_${field.fieldName}`]=null;

 
  			})
}

	reserFilterText()
	{
		this.setState({filter:true})
	}

   handleReset(event)
  {
  		let postObj={};
  		//this.state.filter=false;
  		  		this.setState({isReset:true});
  		  		
  		  		this.setState({filter:false},function(){
					this.setState({filter:true})		
  		  		})
				
  		  		
  	 	this.state.fields[0].fields.map((field)=> {
  			
  			this.state[`Filter_${field.fieldName}`]=null;
			if(field.dataType==='autocomplete')
			{
				this.setState({[field.fieldName]:[],[`Filter_${field.fieldName}`]:''});
				
			}
 
  			})

  			this.setState({activePage:1})
			  getJobRequests(1,{})//.then(response => response.data)
			    .then((response) => {

			
  		  			 		
			        this.setState({ schedules: response.data });
			        this.setState({isLoading:false})
				 
			      	if(parseInt(response.headers["x-total-records"])>this.state.schedules.length)
			      		this.setState({hasMoreItems:true})
			      	else
			      		this.setState({hasMoreItems:false})
			      	  		this.setState({isReset:false});

	     });	
  }

  /*async componentWillReceiveProps(nextProps)
{
  let postObj={};
      
    if(this.props.location.data!==null && this.props.location.data!==undefined)
    {
    console.log(":::::props from dashboard::::::",this.props.location.data);
    postObj=this.props.location.data;
	//console.log("statuskeu props from dashboard:::",this.props.location.data.statusKey);
	if(this.props.location.data.statusKey!==null && this.props.location.data.statusKey!==undefined)
	{
		this.setState({statusFilter:this.props.location.data.statusKey});
	}
	if(this.props.location.data.accountId===null)
	{
		delete postObj.accountId;
		postObj = postObj;
	}
   }

   if(this.props.location.notification!==null && this.props.location.notification!==undefined)
    {
    //console.log(":::::props from header notification::::::",this.props.location.notification);
    let notification = this.props.location.notification.noti;
    //postObj=this.props.location.data;
    let notiObj = {
      isActive:false,
      isDeleted:true
    }
    updateNoti(notification.id,notiObj)
    .then((response)=>
    {
      //console.log(response);
    });
   }


   getJobRequests(1,postObj)//.then(response => response.data)
    .then((response) => {
      this.setState({isLoading:false})
      this.setState({ schedules: response.data,postObj:postObj})
      this.setState({totalCount:response.headers["x-total-records"]});
      if(parseInt(response.headers["x-total-records"])>response.data.length)
        this.setState({hasMoreItems:true,isLoading:false})
      //console.log(this.state.users)
     })
}*/

  loadMore(){

  	let postObj={};
	  	//console.log(this.state.fields[0].fields);
	  	this.state.fields[0].fields.map((field)=> {
	  			
	  			if(this.state[`Filter_${field.fieldName}`]!=undefined && this.state[`Filter_${field.fieldName}`]!='')
	  			{
	  				 if(field.dataType==="lookup")
	  				 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
					 else if(field.dataType==="autocomplete")
					 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
	  				 else if (field.dataType==="date")
	  				 {
	  				 	//alert(field.fieldName+' : '+this.state[`Filter_${field.fieldName}`]);
	  				 	let varSelectedDate=this.state[`Filter_${field.fieldName}`]
	  				 	let formattedDate=format(varSelectedDate, 'yyyy-MM-dd')
	  				 	//const formattedDate = varSelectedDate.getFullYear()+'-'+(varSelectedDate.getMonth()+1)+'-'
	  				 	//+varSelectedDate.getDate();
	  				 	//alert(formattedDate);
	  				 	postObj[field.fieldName]=formattedDate;
	  				 }
	  				 else
	  				 {
	  				 	
	  				 	postObj[field.fieldName]=this.state[`Filter_${field.fieldName}`];
	  				 }
	  			}

	  			})
	if(this.state.statusFilter!==null)
	{
		postObj['statusKey'] = this.state.statusFilter;
	}

  	this.setState({isLoading:true})
    
  		this.setState({page:this.state.page+1},()=>
  	{
     getJobRequests(this.state.page,postObj)//.then(response => response.data)
  	
    .then((response) => 
    {
      this.setState({ schedules:this.state.schedules.concat(response.data) }
      ,()=>{
      	this.setState({isLoading:false})
		
      	if(parseInt(response.headers["x-total-records"])>this.state.schedules.length)
      	this.setState({hasMoreItems:true})
      	else
      		this.setState({hasMoreItems:false})
      	

      });
     })
	});


   
  }

  viewComments=(jobr)=>
  {

  		console.log("jobr",jobr);
  		getJobNotes(jobr.id).then((response) => {
  				this.setState({notes:response.data,notesId:jobr.id})
  				
		});


  }

  updateStatus=(jobr)=>
  {

	let jobRequests = this.state.schedules;
	let index = jobRequests.findIndex(x=>x.jobRequestKey===jobr.jobRequestKey);
	jobRequests[index].jobStatusId = jobr.jobStatusId;
	this.setState({ schedules: jobRequests,open:false});

  }
  
  async componentDidMount()
  {
 
  	//get status

	 await getMenus().then(response => response.data)
		 .then((data) => {
		   
		   if(data[0] != null && data[0].permissions !=null)
					 {
					  
					   console.log(data[0].permissions);
					   let perms="";
					   data[0].permissions.map((per) =>(
						 perms = perms + "," + per
						 ))
					   console.log(perms);
						this.setState({ permission: perms })
	 
					 }
		  });

	await getJobSummary().then(response => response.data)
    .then((data) => {
		let showall=0;
		data.map(d=>{
			showall=parseInt(d.count)+parseInt(showall);
		})
      this.setState({ summary: data,showall:showall })
     // console.log(data);
     });

  	getJobStatus().then(response => response.data)
    .then((data) => {

      this.setState({ mStatus: data })
     // console.log(data);
     });

	 getJobServiceTypes().then(response => response.data)
    .then((data) => {
      this.setState({ jobServiceTypes: data })
     // console.log(data);
     });

	

	getMaster("settings").then(response => response.data)
    .then((data) => {
		data.filter(x=>x.settingsId==="jobstatus").map((stt)=>{
			this.setState({ statusSettings: stt.data.complete })
			//console.log("statusSettings",stt.data.complete);
		
		})
			
      
      //console.log("statusSettings::::",data);
     });

    getAccounts().then(response => response.data)
      .then((data) => {
        this.setState({ mAccounts: data })
       // console.log(data);
       });


  	this.setState({hasMoreItems:false,isLoading:true});
  	getScreenFields('jobrequest')
  	.then((fieldResponse) => {
  		this.setState({fields:fieldResponse.data});

  		//console.log("fieldResponse",fieldResponse.data)
  		
  		let filterLength=fieldResponse.data[0].fields
  			.filter((fieldFilter) => fieldFilter.dataType==='lookup' || fieldFilter.dataType==='autocomplete').length;
  		//alert('loop length : '+filterLength );

  		let loopCounter =0;
  		fieldResponse.data[0].fields
  			.filter((fieldFilter) => fieldFilter.dataType==='lookup' || fieldFilter.dataType==='autocomplete')
  			.map((fieldMap)=>
  					{
  				//		alert(fieldMap.lookUp.lookupName);

  						// if(fieldMap.lookUp.lookupName==="pEntity")
  						// 	{

  						// 		getPatientRights(1,{})
  						// 		.then((filterResponse)=>
								// {
								// 	//console.log('Master :',fieldMap.fieldName);
								// 	//alert(fieldMap.fieldName);
								// 	this.setState({[fieldMap.fieldName]:filterResponse.data});
								// 	loopCounter++;
								// 	if(loopCounter===filterLength)
								// 		this.setState({filter:true});


								// })

  						// 	}
  						// 	else
						
							if(fieldMap.dataType.includes('autocomplete'))
							{
								console.log("datata",fieldMap.dataType);
								this.setState({[fieldMap.fieldName]:[]});
								loopCounter++;
								if(loopCounter===filterLength)
									this.setState({filter:true});

							}
							
							else if(fieldMap.dataType.includes('lookup'))
							{
								console.log("datata",fieldMap.dataType);
								getMaster(fieldMap.lookUp.lookupName)
								.then((filterResponse)=>
									{
										//console.log('Master :',fieldMap.fieldName);
										//alert(fieldMap.fieldName);
										this.setState({[fieldMap.fieldName]:filterResponse.data});
										loopCounter++;
										if(loopCounter===filterLength)
											this.setState({filter:true});


									})
							}
							
						}
  					
  				)
    });

    let postObj={};
			
  	if(this.props.location.data!==null && this.props.location.data!==undefined)
  	{
		console.log(":::::props from dashboard::::::",this.props.location.data);
		postObj=this.props.location.data;
		if(this.props.location.data.statusKey!==null && this.props.location.data.statusKey!==undefined)
		{
			this.setState({statusFilter:this.props.location.data.statusKey});
		}
		if(this.props.location.data.accountId===null)
		{
			delete postObj.accountId;
			postObj = postObj;
		}
	}

  if(this.props.location.notification!==null && this.props.location.notification!==undefined)
    {
    console.log(":::::props from header notification::::::",this.props.location.notification);
    let notification = this.props.location.notification.noti;
    //postObj=this.props.location.data;
    let notiObj = {
      isActive:false,
      isDeleted:true
    }
    updateNoti(notification.id,notiObj)
    .then((response)=>
    {
      console.log(response);
    });
   }

   if(this.state.permission!==null && this.state.permission.includes("DEFAULTJOBSTATUS"))
   {
		//console.log("default :::::::",this.state.permission);
		this.state.permission.split(',').map(item => {

			if(item.includes("DEFAULTJOBSTATUS"))
			{
				postObj.jobStatusKey= item.replace("DEFAULTJOBSTATUS:","").trim();
				
			}

			});

   }


   getJobRequests(1,postObj)//.then(response => response.data)
    .then((response) => {
    	this.setState({isLoading:false})
      this.setState({ schedules: response.data,postObj:postObj})
      this.setState({totalCount:response.headers["x-total-records"]});
      if(parseInt(response.headers["x-total-records"])>response.data.length)
      	this.setState({hasMoreItems:true,isLoading:false})
      //console.log(this.state.users)
     })


  }

  updateItem(jobr)
  {
	console.log("Update Item:::::", jobr);
	let jobRequests = this.state.schedules;
	let index = jobRequests.findIndex(x=>x.jobRequestKey===jobr.jobRequestKey);
	jobRequests[index].invoiceStatus =true;
	this.setState({ schedules: jobRequests,open:false});
  }

  payment(jobr)
  {
	console.log("payment update");
	console.log("Update Item:::::", jobr);
	let jobRequests = this.state.schedules;
	let index = jobRequests.findIndex(x=>x.jobRequestKey===jobr.jobRequestKey);
	jobRequests[index].paidStatus =true;
	this.setState({ schedules: jobRequests,open:false});
  }

  

   async componentWillReceiveProps(nextProps)
  {
	let postObj={};
		
	  if(this.props.location.data!==null && this.props.location.data!==undefined)
	  {
	  console.log(":::::props from dashboard::::::",this.props.location.data);
	  postObj=this.props.location.data;
	//console.log("statuskeu props from dashboard:::",this.props.location.data.statusKey);
	if(this.props.location.data.statusKey!==null && this.props.location.data.statusKey!==undefined)
	{
		this.setState({statusFilter:this.props.location.data.statusKey});
	}
	if(this.props.location.data.accountId===null)
	{
		delete postObj.accountId;
		postObj = postObj;
	}
	 }
  
	 if(this.props.location.notification!==null && this.props.location.notification!==undefined)
	  {
	  //console.log(":::::props from header notification::::::",this.props.location.notification);
	  let notification = this.props.location.notification.noti;
	  //postObj=this.props.location.data;
	  let notiObj = {
		isActive:false,
		isDeleted:true
	  }
	  updateNoti(notification.id,notiObj)
	  .then((response)=>
	  {
		//console.log(response);
	  });
	 }
  
  
	 getJobRequests(1,postObj)//.then(response => response.data)
	  .then((response) => {
		this.setState({isLoading:false})
		this.setState({ schedules: response.data,postObj:postObj})
		this.setState({totalCount:response.headers["x-total-records"]});
		if(parseInt(response.headers["x-total-records"])>response.data.length)
		  this.setState({hasMoreItems:true,isLoading:false})
		//console.log(this.state.users)
	   })
  }
  
handleChangeDate(date)
	{
		if(date!==null && date !== undefined)
		{

			let str = date.substring(5,7) + "/"+ date.substring(8,10) + "/" +date.substring(0,4);

			return " - "+str;
		}
		else
			return ""
		
	}

handleCloseNew = () =>
  {
  	console.log("close new");
    this.setState({open:false});
    let schedule =  this.state.schedule;
	let postObj = {jobRequestKey:schedule.jobRequestId};
  	//if(this.props.location.data!=null)
  	//{
	//	console.log(":::::props from dashboard::::::",this.props.location.data);
	//	postObj=this.props.location.data;
	//}


	

	getJobRequests(1,postObj)//.then(response => response.data)
    .then((response) => {
    	console.log("notes::",response.data.length);
    	if(response.data.length>0)
    	{
			
	    	response.data.map((s) => (
	    		console.log("notes::+",s),
	    		schedule.status = s.status,
	    		schedule.notesCount= s.notesCount,
	    		schedule.notes = s.notes,
	    		schedule.scheduleType = s.scheduleType,
	    		schedule.percentage = s.percentage,
          schedule.startDate = s.startDate,
          schedule.locationKey = s.locationKey,
	    		this.setState({schedules: this.state.schedules.map(el => (el.id === s.id ? {...el, schedule} : el))})	
	        ))
    	}
    	else
    	{
    		console.log("notes::-");
    		schedule.status = 'green';
    		schedule.percentage =100;
    		this.setState({schedules: this.state.schedules.map(el => (el.id === schedule.id ? {...el, schedule} : el))})	
    	}
    	
     })
  }

   handleClose = () =>
  {
    this.setState({open:false});
    let postObj={};
			
  	//if(this.props.location.data!=null)
  	//{
	//	console.log(":::::props from dashboard::::::",this.props.location.data);
	//	postObj=this.props.location.data;
	//}


	getJobRequests(1,postObj)//.then(response => response.data)
    .then((response) => {
    	this.setState({isLoading:false})
      this.setState({ schedules: response.data})
      this.setState({totalCount:response.headers["x-total-records"]});
      if(parseInt(response.headers["x-total-records"])>response.data.length)
      	this.setState({hasMoreItems:true,isLoading:false})
      //console.log(this.state.users)
     })
  }

filterByStatus= (statusId) => {

  let postObj={};
			
  	this.resetFilter();
    console.log("filterby status:::::",statusId);
    if(statusId !=null && statusId!="")
    {
		postObj={
			jobStatusKey: statusId
		};

		this.setState({statusFilter: statusId});
	}

	getJobRequests(1,postObj)//.then(response => response.data)
    .then((response) => {
    	this.setState({isLoading:false})
      this.setState({ schedules: response.data,postObj:postObj})
     
      if(parseInt(response.headers["x-total-records"])>response.data.length)
      	this.setState({hasMoreItems:true,isLoading:false})
      //console.log(this.state.users)
     });
}

 

    handleFilter(event)
	{
	  	let postObj={};
	  		  	this.setState({isLoading:true});

	  	console.log(this.state.fields[0].fields);
	  	this.state.fields[0].fields.map((field)=> {
	  			
	  			if(this.state[`Filter_${field.fieldName}`]!=undefined && this.state[`Filter_${field.fieldName}`]!='' && field.isDummy ===false)
	  			{
	  				 if(field.dataType==="lookup")
	  				 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
					 else  if(field.dataType==="autocomplete")
					 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
	  				 else if (field.dataType==="date")
	  				 {
	  				 	//alert(field.fieldName+' : '+this.state[`Filter_${field.fieldName}`]);
	  				 	let varSelectedDate=this.state[`Filter_${field.fieldName}`]
	  				 	let formattedDate=format(varSelectedDate, 'yyyy-MM-dd')
	  				 	//const formattedDate = varSelectedDate.getFullYear()+'-'+(varSelectedDate.getMonth()+1)+'-'
	  				 	//+varSelectedDate.getDate();
	  				 	//alert(formattedDate);
	  				 	postObj[field.fieldName]=formattedDate;
	  				 }
					 else if(field.dataType==="dropdown")
	  				 {	  				 	
	  				 	postObj['cdnbool'+field.fieldName]=this.state[`Filter_${field.fieldName}`].toString();
	  				 }
	  				 else
	  				 {
	  				 	
	  				 	postObj[field.fieldName]=this.state[`Filter_${field.fieldName}`];
	  				 }
	  			}

	  			})
	  			this.setState({activePage:1})
	  		   
	  		    getJobRequests(1,postObj)
					    .then((response) => {
					      this.setState({ schedules: response.data,page:1 , postObj:postObj})
					      this.setState({totalCount:response.headers["x-total-records"]});
					      if(parseInt(response.headers["x-total-records"])>response.data.length)
					      	this.setState({hasMoreItems:true})
					      else
					      	this.setState({hasMoreItems:false})
				this.setState({isLoading:false});					     })
	}

	autocompleteOnChange=(event,newValue,fieldName,lookupKey) => {
		if(event!==null && newValue!==null)
		{
		  console.log("autocomplete change:::",event ,newValue,fieldName,lookupKey,newValue[lookupKey]);
		  this.setState({[fieldName]:newValue[lookupKey]});
		}
		
	  }
	
	  autocompleteOnInputChange=async (event,value,fieldName,lookupKey,lookupName) =>  {
		if(event!==null && value!==null && value.length>3)
		{
		  //console.log("autocomplete input change:::",event ,value,fieldName,lookupKey);
		  //this.setState({[fieldName]:newValue[lookupKey]});
		  var postObj = {
			patientNameLCase: value.toLowerCase()
			
		  };
		  let patientData=[];
		
			await getJobRequests(1,postObj)
			  .then((response) => {
				  response.data.map((p)=>(
					 patientData.push(p)
				  ))
				  this.setState({ [fieldName]:patientData});
		   });
		   /*await getMaster(lookupName)
			.then((filterResponse)=>
			{
				this.setState({[fieldName]:filterResponse.data});
			});*/
		}
		
	  }

  editdigitalPlanner(job)
  {

  	this.setState({dpDialogOpen:true,selectedRequest:job});
  }

	  

	 exportClick(event)
	{
	  	let postObj={};
	
	  	this.state.fields[0].fields.map((field)=> {
	  			
	  			if(this.state[`Filter_${field.fieldName}`]!=undefined && this.state[`Filter_${field.fieldName}`]!='' && field.isDummy===false)
	  			{
	  				 if(field.dataType==="lookup")
	  				 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
					 else if(field.dataType==="autocomplete")
						 postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
	  				 else if (field.dataType==="date")
	  				 {
	  				 	//alert(field.fieldName+' : '+this.state[`Filter_${field.fieldName}`]);
	  				 	let varSelectedDate=this.state[`Filter_${field.fieldName}`]
	  				 	let formattedDate=format(varSelectedDate, 'yyyy-MM-dd')
	  				 	//const formattedDate = varSelectedDate.getFullYear()+'-'+(varSelectedDate.getMonth()+1)+'-'
	  				 	//+varSelectedDate.getDate();
	  				 	//alert(formattedDate);
	  				 	postObj[field.fieldName]=formattedDate;
	  				 }
					   else if(field.dataType==="dropdown")
						{	  				 	
							postObj['cdnbool'+field.fieldName]=this.state[`Filter_${field.fieldName}`].toString();
						}
	  				 else
	  				 {
	  				 	
	  				 	postObj[field.fieldName]=this.state[`Filter_${field.fieldName}`];
	  				 }
	  			}

	  			}) 
	  		   
	  		    getDpExport(postObj)
					    .then((response) => {
					      if(response.data!=""){
					    	var win = window.open(response.data, '_blank');
  							win.focus();}
  							else
  								alert('Error exporting records')
					    })
	}

  render() {
  	//console.log("schedule::::",this.state.schedule);
    return (
      <>

      {

      	<div className="row">

          <div className="col-md-12">
            <CodeExample jsCode="true" beforeCodeTitle="Search Digital Planning Requests" csv ="true" exportClick={this.exportClick.bind(this)}>
              <div className="kt-section" >
              <Grid container spacing={3}>
      		  {
      			this.state.filter &&
		    	
		    	this.state.fields.map((screen) => (
		    		screen.fields.map((field)=>{
						
							if(field.dataType==='String')
							
							return(
								<Grid item xs={12} sm={6}>
									 <TextField  name={field.fieldName} label={field.displayName}
									 onChange={e=>this.setState({[`Filter_${field.fieldName}`]:e.target.value})}
									 />
						    	</Grid>
						    )
							 else if(field.dataType==='dropdown')
														
														return(
															<Grid item xs={12} sm={6}>
									
						    		 <TextField  style={{'width':'100%'}} name={field.fieldName}
									 select
									 label={field.displayName}
									 onChange={e=>this.setState({[`Filter_${field.fieldName}`]:e.target.value})}
									 >
									 {
										field.items.map((filter) => {
											return(
											<MenuItem key={filter.name} 
											value={filter.value}>
											{

												 
															filter.name
													
												
											}</MenuItem>)
										})
									
									}
									</TextField>
									
									</Grid>
														 )		
						    else if(field.dataType==='lookup' )
						    	return(
						    		<Grid item xs={12} sm={6}>
									 {field.lookUp.filterFieldName !==undefined && field.lookUp.filterFieldName!==null &&
						    		 <TextField   style={{'width':'100%'}} name={field.lookUp.lookupKey}
									 select
									 label={field.displayName}
									 onChange={e=>this.setState({[`Filter_${field.fieldName}`]:e.target.value})}
									 >
									 {
										this.state[field.fieldName].filter(x=>x[field.lookUp.filterFieldName]===this.state[`Filter_${field.lookUp.filterFieldName}`]).map((filter) => {
											return(
											<MenuItem key={filter[field.lookUp.lookupId]} 
											
											value={filter[field.lookUp.lookupId]}>

											{

												field.lookUp.lookupDisplay.split(/\s*,\s*/)
												.map((keyVal) => {
															return(<>{filter[keyVal]} </>);
													}
												)
											}</MenuItem>)
										})
									
									}
									</TextField>
									}
									{field.lookUp.filterFieldName ===undefined || field.lookUp.filterFieldName===null &&
						    		 <TextField   style={{'width':'100%'}} name={field.lookUp.lookupKey}
									 select
									 label={field.displayName}
									 onChange={e=>this.setState({[`Filter_${field.fieldName}`]:e.target.value})}
									 >
									 {
										this.state[field.fieldName].map((filter) => {
											return(
											<MenuItem key={filter[field.lookUp.lookupId]} 
											
											value={filter[field.lookUp.lookupId]}>

											{

												field.lookUp.lookupDisplay.split(/\s*,\s*/)
												.map((keyVal) => {
															return(<>{filter[keyVal]} </>);
													}
												)
											}</MenuItem>)
										})
									
									}
									</TextField>
									}
									</Grid>
						    )
							 else if(field.dataType==='checkbox')
							
							return(
								<Grid item xs={12} sm={6}>
						    	Show Archived <Checkbox name={field.fieldName} value={true} onChange={e=>this.setState({[`Filter_${field.fieldName}`]:(!this.state[`Filter_${field.fieldName}`]).toString()})} />
					         </Grid>
					         )		
							else if(field.dataType==='autocomplete')
						    	return(
						    		 <Grid item xs={12} sm={6}>
										 <Autocomplete
											id={field.lookUp.lookupKey}
											name={field.lookUp.lookupKey}
											value={this.state[`Filter_${field.fieldName}`]}
											options={this.state[field.fieldName]}
											autoComplete={true}
											clearOnBlur={true}
											getOptionLabel={(option) => option[field.lookUp.lookupDisplay] + this.handleChangeDate(option['deliveryDate']) }
											onChange={(event,newValue)=>{this.autocompleteOnChange(event,newValue,`Filter_${field.fieldName}`,field.lookUp.lookupId);}}
											onInputChange={(event,value)=>{this.autocompleteOnInputChange(event,value,field.fieldName,field.lookUp.lookupId,field.lookUp.lookupName);}}						
											renderInput={(params) => <TextField {...params} label={field.displayName}/>}
										/>
						    		 </Grid>
						    )
						    else	 if(field.dataType==='date' )
							return(
								<Grid item xs={12} sm={6}>
									<MuiPickersUtilsProvider  utils={DateFnsUtils}>
		      
										        <KeyboardDatePicker
										          fullWidth
										          id="date"
										          label={field.displayName}
										          name = {field.fieldName}
										          format="MM/dd/yyyy"
										          value={this.state[`Filter_${field.fieldName}`]!=null ? this.state[`Filter_${field.fieldName}`] : null}
										          onChange={date =>this.setState({[`Filter_${field.fieldName}`]:date,selectedDate:date})}
										          KeyboardButtonProps={{
										            'aria-label': 'change date',
										          }}
										        />
										      
								    </MuiPickersUtilsProvider>
								
								</Grid>
															    
						    )
						   
						
		    			}) //{/* map  inner loop close*/}
		    		)) //{/* map loop close*/}
			}
			</Grid>
	    	</div>
		    	
		    	<div>
		    	<Button
				variant="outlined"
				color="primary"
				onClick={this.handleFilter.bind(this)}
				endIcon={<Icon>search</Icon>}
				style={{'padding':'10px','margin':'10px'}}
				>
				{
					this.state.isLoading==true&&<><Bounce /></>
				}
				{
					this.state.isLoading==false&&<>Apply Filter</>
				}
				</Button>
				
				<Button
				variant="outlined"
				color="primary"
				onClick={this.handleReset.bind(this)}
				endIcon={<Icon>backspace</Icon>}
				style={{'padding':'10px','margin':'10px'}}
				>
				{
					this.state.isReset==true&&<><Bounce /></>
				}
				{
					this.state.isReset==false&&<>Reset Filter</>
				}
				</Button>
 				</div>

            </CodeExample>
          	</div>
            </div>
		    }
	
			<div className="row">
				<div className="col-lg-12" style={{padding:'10px',alignItems:"end"}}>
						 <Tooltip
																					  title= {this.state.showtodo?"Hide Widgets":"Show Widgets"}
																					  >
																						<Button
																						variant="outlined"
																						color="primary"
																							onClick={() => this.setState({showtodo:!this.state.showtodo})}
																							
																						  >
																							{this.state.showtodo?"Hide Widgets":"Show Widgets"}
																						  </Button>
																						  </Tooltip>
        			</div>
					</div>
					{this.state.showtodo &&
					<div className="row">
		                {this.state.mStatus!=null && this.state.mStatus.map((status)=>(
							<div className="col-lg-2">
														<Portlet fluidHeight={20} style={{'cursor': 'pointer'}} className="kt-portlet--border-bottom-brand" onClick={()=>this.filterByStatus(status.jobStatusId)} >
															<PortletBody fluid={true}>
															
																<div className="kt-widget26">
																<div className="kt-widget26__content">
																<span className="kt-widget26__number" style={{'color':status.statusId,fontSize:'14px'}}> 
																		{this.state.summary.filter(s=> s.statusId==status.jobStatusId).map((sum)=>(
																				sum.count
																		))}
																	
																</span>
																<span className="kt-widget26__desc" style={{'color': status.jobStatusColor,fontSize:'14px'}}> {status.jobStatusName} </span>
																</div>
																</div>
															
															</PortletBody>
														</Portlet>

							</div>

		                  ))}
						  <div className="col-lg-2">
						  <Portlet  fluidHeight={20} style={{'cursor': 'pointer'}} className="kt-portlet--border-bottom-brand" onClick={()=>this.filterByStatus(null)} >
								<PortletBody fluid={true}>
								
									<div className="kt-widget26">
									<div className="kt-widget26__content">
									<span className="kt-widget26__number" style={{'color':'#2c3e50',fontSize:'14px'}}> 
											
										{this.state.showall}
									</span>
									<span className="kt-widget26__desc" style={{'color': '#2c3e50',fontSize:'14px'}}> {'Show All'} </span>
									</div>
									</div>
								
								</PortletBody>
			  				</Portlet>

		                 
		       
		     	
			 </div>
			 </div>
  			}
		{
			this.state.isLoading===false && this.state.schedules.length===0 &&
			<div style={{"display":"flex","align-items":"center","justify-content": "center"}}>
				<Icon fontSize="large">search</Icon>
				<h2>No matching results found</h2>
			</div>
			
		}
      	{	


      		this.state.schedules.map((sch)=> (
      		
      			<>
      		
      
       
			<div className="kt-portlet">

				<div className="kt-portlet__body">
					<div className="kt-widget kt-widget--user-profile-3">
						<div className="kt-widget__top">
												<div className="kt-widget__media kt-hidden-">
													<img src="media/users/default.jpg" alt="user"/>
												</div>
												<div className="kt-widget__pic kt-widget__pic--danger kt-font-danger kt-font-boldest kt-font-light kt-hidden">
													JM
												</div>
												<div className="kt-widget__content">
													<div className="kt-widget__head">
														<a href='#' className="kt-widget__username">
															 <Link
                    to={{pathname:"/viewplanner", search:"?id="+sch.id+"&key="+sch.pEntity.id, data: sch,fromPath: "/digitalplanner", postObj: this.state.postObj, page: this.state.page}} target="_blank"
                    >
                  {sch.pEntity.firstName} {sch.pEntity.lastName}  &nbsp;&nbsp; 
                </Link>
															
															{/* sch.status == "green" && <i className="flaticon2-correct kt-font-success"></i>*/}
															{
															this.state.mStatus!=null &&
															(
															this.state.mStatus.filter(sts=> sts.jobStatusId==sch.jobStatusId).map((fsts)=>(
																
																<button className="btn btn-success btn-small" style={{background:fsts.jobStatusColor,borderColor:fsts.jobStatusColor,fontSize:'9px',height:'16px', padding:'2px'}}>{fsts.jobStatusName}</button>

																
															))
															)
															
														}
																												
														<Tooltip title="Update Status"><IconButton onClick={()=>this.setState({open:true,schedule:sch, tStatus: sch.status})} >
															<EditIcon style={{ color: '#5578eb',fontSize: 14
														}}/>  
														</IconButton>
														
														</Tooltip>

														

														</a>
														
														{/*<div className="kt-widget__action">
															
															
															&nbsp;
															 { sch.status != "green" && <button type="button" onClick={()=> this.completeSchedule(sch)} className="btn btn-brand btn-sm btn-upper">Mark Complete</button>}
															 { sch.status == "green" && <button type="button" onClick={()=> this.undoSchedule(sch)} className="btn btn-brand btn-sm btn-upper">Undo</button>}
														</div>
														*/}
														<div className="kt-widget__action">
															{sch.jobStatusId !== "JOBS00003" && sch.ageing!==null && sch.ageing !== "" &&  parseInt(sch.ageing)<=7 && parseInt(sch.ageing)>0 && 
															<div style={{'color':'red'}}> {'Surgery Planned In: ' + sch.ageing +  ' day(s)'}</div>
  															}
															{sch.jobStatusId !== "JOBS00003" && sch.ageing!==null && sch.ageing !== "" &&  parseInt(sch.ageing)>7 && 'Surgery Planned In: ' + sch.ageing +  ' day(s)'}
															{sch.jobStatusId !== "JOBS00003" && sch.ageing!==null && sch.ageing !== "" &&  parseInt(sch.ageing)<0 && 
															<div style={{'color':'red'}}> {'Surgery Planned In: ' + 'Date Passed'}</div>
  															}

															{ this.state.permission.includes("CREATE:JOB")  && 
															<button type="button" onClick={()=> this.editdigitalPlanner(sch)} className="btn btn-brand btn-sm btn-upper">Edit</button>
													        }
															
															{this.state.permission.includes("ARCHIVE:JOB") && sch.isActive && !sch.isDeleted && sch.jobStatusId === "JOBS00003" &&
																													<button type="button" onClick={()=> this.archive(sch,true)} className="btn btn-brand btn-sm btn-upper">Archive</button>
															
																													}
																													{this.state.permission.includes("ARCHIVE:JOB") && !sch.isActive && sch.isDeleted &&
																													<button type="button" onClick={()=> this.archive(sch,false)} className="btn btn-brand btn-sm btn-upper">Retrieve</button>
															
																													}
															 { sch.jobStatusId ===this.state.statusSettings &&  sch.invoiceStatus===false && this.state.permission.includes("CREATE:JOBINVOICE") && 
															 <Tooltip title="Create Invoice"><a href='#' onClick={()=>this.handleOpenInvoiceDrawer(sch)} >
																<IconButton>
																	<DescriptionIcon style={{ color: '#5578eb',fontSize: 18
																	}}/>  
																</IconButton></a> 
															</Tooltip>}
															 { sch.jobStatusId === this.state.statusSettings &&  sch.invoiceStatus===true && this.state.permission.includes("VIEW:JOBINVOICE") && 
															 <Tooltip title="View Invoice & Payment"><a href='#' onClick={()=>this.handleOpenInvoiceViewDrawer(sch)} >
																<IconButton>
																	<ReceiptIcon style={{ color: '#5578eb',fontSize: 18
																	}}/>  
																</IconButton></a> 
															</Tooltip>}
														</div>
														
													</div>
													<div className="kt-widget__subhead">
														<Tooltip title="Payment Status"><a href='#' style={{'pointer-events': 'none','cursor': 'pointer'}} ><i className="flaticon2-tag"></i>{sch.paidStatus? "Paid" : "Not Paid"}</a></Tooltip>
														{/*<a href='www.smartch.com' ><i className="flaticon2-calendar-3"></i>{sch.startDate} </a>*/}
														
														<Tooltip title="Assigned By"><a href='#' style={{'pointer-events': 'none','cursor': 'pointer'}} ><i className="flaticon2-calendar-3"></i>
														
														{
															this.state.mAccounts!=null && sch.referredAccountKey!==null &&
															(
															this.state.mAccounts.filter(acc=> acc.accountId==sch.referredAccountKey).map((facc)=>(
																facc.accountName
															))
															)
															
														}
														
														
														</a></Tooltip>
														<Tooltip title="Surgery Date"><a href='#' style={{'pointer-events': 'none','cursor': 'pointer'}} ><i className="flaticon2-calendar-3"></i>Surgery Date: {sch.deliveryDate!==null && sch.deliveryDate!==undefined ? format(new Date(sch.deliveryDate), 'MM/dd/yyyy'): '#N/A'} </a></Tooltip>
														<a href='#' style={{'pointer-events': 'none','cursor': 'pointer'}} ><i className="flaticon2-list-1"></i>Treatment Recommendations: {sch.treatmentPlansDisplay!==null && sch.treatmentPlansDisplay!==undefined ? sch.treatmentPlansDisplay.join(", "): '#N/A'}  </a>
														<a href='#' style={{'pointer-events': 'none','cursor': 'pointer'}} ><i className="flaticon2-list-2"></i>Implant: {sch.implantTypesDisplay!==null && sch.implantTypesDisplay!==undefined ? sch.implantTypesDisplay.join(", "): '#N/A'}  </a>




													</div>
													<div className="kt-widget__info">
														<div className="kt-widget__desc">
															{sch.notes}
														</div>
														
													</div>
												</div>
						</div>
					 
					</div>
					<div className="kt-widget__footer">
													<div className="kt-widget__wrapper">
														<div className="kt-widget__section">
															
															<div className="kt-widget__blog">
																<i className="flaticon2-talk"></i>
																<a className="kt-widget__value kt-font-brand" onClick={()=>this.viewComments(sch)}>{' '+sch.notesCount} Tooth # / Notes</a>
															</div>

														</div>

													</div>
													{this.state.notes!=null && this.state.notes!=undefined && this.state.notesId==sch.id &&
													<div className="kt-chat">
														<div className="kt-portlet__body">
															<div className="kt-scroll kt-scroll--pull" data-mobile-height="300">
															    {this.state.notes!=null && this.state.notes.map((notes)=>(
																<div className="kt-chat__messages" key={notes.id}>
																	<div className="kt-chat__message">
																		<div className="kt-chat__user">
																			<span className="kt-media kt-media--circle kt-media--sm">
																				<img src="media/users/default.jpg" alt="image"/>
																			</span>
																			<a href="#" className="kt-chat__username"></a>
																			<span className="kt-chat__datetime">{notes.createdByFirstName + ' ' + notes.createdByLastName} {format(new Date(notes.createdOn), 'MM/dd/yyyy hh:mm')}</span>
																		</div>
																		<div className="kt-chat__text kt-bg-light-success">
																			{notes.notes}
																		</div>
																	</div>
																	
																</div>
																))}
															</div>
														</div>
														
										
													</div>
													}
													
												</div>
				</div>
			</div>
			
		
		</>
		))}
	
		{this.state.schedule!=null &&
		<Dialog fullWidth={true}
        maxWidth={'xs'} open={this.state.open} onClose={this.handleCloseNew} aria-labelledby="form-dialog-title">
       
        <DialogTitle id="form-dialog-title">{this.state.schedule.pEntity.firstName+ ' ' +this.state.schedule.pEntity.lastName}</DialogTitle>
        <DialogContent>
          <EditJobrStatus jobRequest={this.state.schedule} onUpdate={()=>this.updateStatus(this.state.schedule)} />
        </DialogContent>
      

        <DialogActions>
          <Button onClick={this.handleCloseNew} color="primary">
            Close
          </Button>
        
         
         
        </DialogActions>
         
      </Dialog>		
      }	

	  {/**digital planner */}
				{this.state.selectedRequest !== null &&
				<Dialog open={this.state.dpDialogOpen} onClose={this.handleDpDialogClose} aria-labelledby="form-dialog-title"
				fullWidth={true}
			   fullScreen
				>
					
				   
					<DialogTitle id="form-dialog-title">Edit Job Order</DialogTitle>
					<DialogContent>
					 
					  
					<EditJobRequest jobRequest={this.state.selectedRequest}/>
					</DialogContent>
				  
	  
					<DialogActions>
					  <Button onClick={this.handleDpDialogClose} color="primary">
						Close
					  </Button>
					  
					  
					  
					</DialogActions>
					 
				  </Dialog>
			  }		
					
       
		{/*</InfiniteScroll>*/}
		{
			this.state.hasMoreItems &&
			<div style={{display:'flex', alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'}}>

        <Button
				variant="outlined"
				color="primary"
				onClick={this.loadMore.bind(this)}
				
				style={{'padding':'10px','margin':'10px'}}
				>
				{
					this.state.isLoading==true&&<><Bounce /></>
				}
				{
					this.state.isLoading==false&&<><SearchIcon style={{ color: '#5867dd',fontSize: 25}}/>  Load More</>
				}
				</Button>

			
		</div>
		}

		{/**invoice attributes drawer */}
		{this.state.selectedDrawerItem!=null && this.state.jobServiceTypes.length>0 &&
		<Drawer anchor={'right'} open={this.state.invoiceDrawerOpen} onClose={this.toggleInvoiceDrawer}>
			<InvoiceAttributes onUpdate={()=>this.updateItem(this.state.selectedDrawerItem)} onClose={()=>this.setState({invoiceDrawerOpen:false})} jobRequest={this.state.selectedDrawerItem} serviceTypes={this.state.jobServiceTypes} />
        </Drawer>
  		}

		
		{/**invoice drawer */}
		{this.state.selectedDrawerItem!=null && this.state.jobServiceTypes.length>0 &&
		<Drawer anchor={'right'} open={this.state.invoiceDrawerViewOpen} onClose={this.toggleInvoiceViewDrawer}>
			<Invoice onClose={()=>this.setState({invoiceDrawerViewOpen:false})} onPayment={()=>this.payment(this.state.selectedDrawerItem)} jobRequest={this.state.selectedDrawerItem} serviceTypes={this.state.jobServiceTypes} permission={this.state.permission} />
        </Drawer>
  		}
    
      </>
    );
  }
}
